import React from 'react';
import {useStyles} from './SkipNavLink.styles';

const SkipNavLink = ({id, children="Skip to content"}) => {
    const classes = useStyles();

    return (
        <div className={classes.skipNavLinkContainer}>
            <a
                className={classes.skipNavLink}
                href={`#${id}`}
                >
                {children}
            </a>
        </div>
    );
};

export default SkipNavLink;
